import * as React from 'react';
export const externalSvg = React.forwardRef(function externalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.25 3a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h6A.75.75 0 0 0 9 9.75v-1.5a.75.75 0 1 1 1.5 0v1.5A2.25 2.25 0 0 1 8.25 12h-6A2.25 2.25 0 0 1 0 9.75v-6A2.25 2.25 0 0 1 2.25 1.5h1.5a.75.75 0 1 1 0 1.5h-1.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7 0a.75.75 0 1 0 0 1.5h2.44L3.72 7.22a.75.75 0 1 0 1.06 1.06l5.72-5.72V5A.75.75 0 0 0 12 5V.75a.75.75 0 0 0-.75-.75H7Z',
    }),
  );
});
externalSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var external = {
  category: 'icon',
  colorable: true,
  name: 'external',
  svg: externalSvg,
};
